<template>
	<div class="flex flex-row flex-wrap">
		<div class="col-12 xl:col-12">
			<div class="card property-services-section">

				<!-- Services header with edit lock/unlock -->
				<div class="grid">
					<!-- Title -->
					<div class="col"><h4>Services</h4></div>

					<!-- Lock/Unlock-->
					<div class="col-fixed align-self-end align-items-center" >
						<ProgressSpinner style="width:40px;height:40px" strokeWidth="3" v-if="loading" />
						<a @click="showNotes=!showNotes" class="mr-4">
							<i v-if="showNotes" class="pi pi-comments" style="font-size: 1.5rem" v-tooltip.top="'Show / Hide notes'" />
							<i v-if="!showNotes" class="pi pi-comments" style="font-size: 1.5rem; color:gray" v-tooltip.top="'Show / Hide notes'" />
						</a>
						<a @click="editMode=!editMode;editModeChanged()" v-if="isInternalUser">
							<i v-if="editMode" class="pi pi-lock-open" style="font-size: 1.5rem" />
							<i v-if="!editMode" class="pi pi-lock" style="font-size: 1.5rem" />
						</a>
					</div>
				</div>

				<!-- Filter text box -->
				<div style="margin:10px;" class="flex ml-0 mr-0">
					<div class="w-100pc p-input-icon-left p-input-icon-right">
						<i class="pi pi-home" />
						<InputText v-model="serviceListFilter" placeholder="Service keyword filter.." />
						<i class="pi pi-search" />
					</div>
					<div class="align-items-center" style="position:relative" v-if="editMode">
						<Button @click="toggleNewService" class="ml-1 mr-1" icon="pi pi-plus" v-if="!showAddService" />
						<Button @click="toggleNewService" class="ml-1 mr-1" icon="pi pi-minus" v-if="showAddService" />
						<Listbox v-if="showAddService" v-model="selectedNewService" :options="allServices" :filter="true" :filterFields="['serviceName']" :filterPlaceholder="'Find a service'" listStyle="max-height:250px;width:300px;" style="position: absolute; right: 0px; top: 50px; z-index: 1;" @change="addService">
							<template #value="data">
								<span v-if="data.value.serviceName">{{data.value.serviceName}}</span>
							</template>
							<template #option="data">
								<span>{{data.option.serviceName}}</span>
							</template>
						</Listbox>
					</div>

					<div style="position:relative;">
						<!--Snooze listbox-->
						<Listbox v-if="showSnoozeOptions" v-model="selectedSnoozeDays" :options="snoozeOptions" optionValue="value" optionLabel="label"
								 listStyle="max-height:250px;width:300px;"
								 style="position: absolute; right: 0px; top: 50px; z-index: 991;"
								 @change="snoozeSupplierEmails">
							<template #header>
								<div class="p-2">
									<div class="text-right">
										<a  @click="showSnoozeOptions = false;">
											<i class="pi pi-times " />
										</a>
									</div>
									<span>Snooze options for:</span>
									<br />
									<span class="compass-red">{{selectedPropertyServiceToSnooze.serviceName}}</span>
								</div>
							</template>
						</Listbox>
					</div>
				</div>

				<!-- Services Table-->
				<div style="width:100%;">
					<DataView :value="filteredServices"
							  datakey="propertyServiceId"
							  :paginator="true"
							  :rows="50"
							  :scrollable="true"
							  stripedRows
							  class="p-datatable-sm property-service-table"
							  :paginatorTemplate="paginatorTemplate"
							  :rowsPerPageOptions="[10,20,50,100,200]"
							  responsiveLayout="scroll"
							  :alwaysShowPaginator="false"
							  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">

						<template #header>
							<div class="col-12">
								<div class="grid flex-nowrap">
									<div class="col-2">Service</div>
									<div class="col-1 hidden md:block service-ref ">Ref</div>
									<div class="col-fixed hidden md:block service-type">Service Type</div>
									<div class="col-2 hidden md:block">Supplier</div>
									<div class="text-center col-fixed service-aniv">Anniversary &nbsp; Previous</div>
									<div class="col-fixed service-price" v-if="$store.getters.isInternalUser">Price / Interval</div>
									<div class="col-fixed last-email-to-supplier-sent">Last Email Sent</div>
									<div class="col-fixed service-active">Active</div>
									</div>
								</div>
						</template>

						<template #list="{data}">
							<div class="col-12 property-service-item hover-row" v-bind:class="[getServiceClass(data)]">

								<!-- First data section has service name / ref / supplier / price  -->
								<div class="grid flex-nowrap">
									<!--if is newly added PropertyService-->
									<small class="ml-1 mt-1" style="color:red" v-if="loadedTime < data.whenCreated">[new]</small>

									<div class="col-2 service-name compass-red" v-bind:class="[data.parentServiceId ? 'pl-4':'']">
										{{data.serviceName}}
										<div style="margin-left:50px;margin-top:4px;" v-if="editMode && !hasContentOrWhitespace(data.adminNotes) && !hasContentOrWhitespace(data.exceptionNotes) && showNotes"><i class="pi pi-comment" @click="toggleNotes(data)" /></div>
									</div>
									<div class="col-fixed hidden md:block service-ref">
										<span v-if="!editMode">{{data.ref}}</span>
										<InputText v-if="editMode" v-model="data.ref"></InputText>
									</div>
									<div class="col-fixed hidden md:block lg:col-1 service-type">
										<span v-if="!editMode && data.serviceType">{{data.serviceType.replace(' Service','')}}</span>
										<Dropdown class="flex" v-if="editMode" v-model="data.serviceType" :options="serviceTypes" />
									</div>
									<div class="col-2 hidden md:block">
										<Multiselect :options="supplierList"
													 :searchable="true"
													 :limit="40"
													 :filter="true"
													 class="flex"
													 v-model="data.supplierCompanyId"
													 valueProp="id"
													 label="nameAndId"
													 track-by="nameAndId"
													 placeholder="Select a Supplier"
													 @select="updateSupplierName(data)"
													 @clear="clearSupplierName(data)"
													 v-if="editMode" />
										<div class="flex" v-if="!editMode">
											<span v-if="data.supplierName">{{data.supplierName}}</span>
											&nbsp;
											<a v-if="data.supplierCompanyId && $store.getters.isInternalUser || $store.getters.isCustomer" @click="toggleSupplierDetails(data)">
												<i class="pi pi-info-circle" />
											</a>

											<!--Only display envelope to authorised users-->
											<a class="ml-2" @click="toggleSupplierEnvelope(data)" v-tooltip.top="'Automated Email'" v-if="$store.getters.isInternalUser && data.supplierCompanyId && showEnvelopeForSubServiceLine(data)">
												<i class="pi pi-envelope" />
											</a>
										</div>
									</div>
									<div class="text-center col-fixed service-aniv">
										<div class="grid flex-nowrap p-2" v-if="editMode">
											<Calendar v-model="data.whenNextServiceAnniversary" dateFormat="d M yy" /><Button class="flex" icon="pi pi-plus" @click="data.whenNextServiceAnniversary = addYear(data.whenNextServiceAnniversary)" v-tooltip.top="'Add 1 year'"></Button> &nbsp;
											<Calendar v-model="data.whenLastComplianceReceived" dateFormat="d M yy" /><Button icon="pi pi-plus" @click="data.whenLastComplianceReceived = addYear(data.whenLastComplianceReceived)" v-tooltip.top="'Add 1 year'"></Button>
										</div>
										<span v-if="!editMode">
											<span v-if="data.whenNextServiceAnniversary">
												{{formattedDate(data.whenNextServiceAnniversary)}}
											</span>
											<span v-else>Not assigned</span>
											&nbsp;
											<span v-if="data.whenLastComplianceReceived">
												{{formattedDate(data.whenLastComplianceReceived)}}
											</span>
											<span v-else>Not assigned</span>
										</span>
									</div>
									<div class="col-fixed text-right service-price" v-if="$store.getters.isInternalUser" >
										<div class="grid flex-nowrap p-2" v-if="editMode">
											<InputNumber v-model="data.price" class="price-input" mode="decimal" :minFractionDigits="2" />
											<span class="mt-2 ml-2" v-tooltip.top="'invoicing interval'">{{data.intervalMonths}}</span>
										</div>
										<div v-if="!editMode">
											<span>${{data.price}} /</span><span v-tooltip.top="'invoicing interval'"> {{data.intervalMonths}}</span>
										</div>
									</div>
									<div class="col-fixed last-email-to-supplier-sent">
										<div v-if="data.whenLastSupplierEmailTriggered > data.whenLastSupplierEmailSent" class="text-center">
											<span v-tooltip.top="lastTriggeredTooltip(data.whenLastSupplierEmailTriggered)">Queued</span>
										</div>
										<div class="text-center" v-else>
											<span v-tooltip.top="lastTriggeredTooltip(data.whenLastSupplierEmailTriggered)">{{formattedDate(data.whenLastSupplierEmailSent)}}</span>
											<br />
											<template v-if="!editMode && data.whenSupplierEmailsSnoozedUntil > new Date()">	
												(Snoozed)
											</template>
										</div>
									</div>
									<div class="col-fixed text-right service-active">
										<a @click="data.active =!data.active" v-tooltip.top="'Toggle active'" v-if="editMode">
											<i class="pi pi-circle-fill mt-2" v-if="data.active" />
											<i class="pi pi-circle mt-2" v-else />
										</a>
										<i class="pi pi-check ml-4" v-else-if="data.active" />
									</div>
									<div class="col text-right pl-0" v-if="editMode">
										<a @click="data.whenDeleted = new Date();" v-tooltip.top="'Remove service'">
											<i class="pi pi-times mt-2" />
										</a>
									</div>
								</div>

								<!-- Second data item section has comments -->
								<div class="grid" v-if="(editMode || hasContent(data.adminNotes) || hasContent(data.exceptionNotes)) && showNotes">
									<!-- Ident second row-->
									<div class="col-1" style="text-align:right;">
									</div>
									<div class="col-11">

										<!-- Show internal admin notes, only if we are an administrator, and if has content or editing-->
										<template v-if="$store.getters.isInternalUser">
											<div class="notes-block" v-if="hasContent(data.adminNotes) || (editMode && (hasContentOrWhitespace(data.adminNotes) || hasContentOrWhitespace(data.exceptionNotes)))">
												<div class="notes-block-label" v-tooltip.top="'Internal admin notes are available to Compass admin staff, but not shared with customer logins.'">Internal Notes</div>
												<div class="notes-block-content">
													<span v-if="!editMode">{{data.adminNotes}}</span>
													<TextArea v-if="editMode" v-model="data.adminNotes" rows="2" :autoResize="true" />
												</div>
											</div>
										</template>

										<!-- Show exception notes if has content, or editing-->
										<div class="notes-block" v-if="hasContent(data.exceptionNotes) || (editMode && (hasContentOrWhitespace(data.adminNotes) || hasContentOrWhitespace(data.exceptionNotes)))">
											<div class="notes-block-label" v-tooltip.top="'Exception notes are visible to customer logins.'">Exception Notes</div>
											<div class="notes-block-content">
												<span v-if="!editMode">{{data.exceptionNotes}}</span>
												<TextArea v-if="editMode" v-model="data.exceptionNotes" rows="2" :autoResize="true" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</DataView>
				</div>
			</div>
		</div>
	</div>

	<Sidebar v-model:visible="showSupplierDetails" :baseZIndex="1000" position="right" class="p-sidebar-md">
		<CompanySummaryPanel :companyId="supplierSummaryId" />

		<!--Generating templates should only be available to internal users-->
		<template v-if="$store.getters.isInternalUser">
			<div class="col-4 p-0 m-0" v-for="doc in documentTypes.supplier" :key="doc.label">
				<Button class="template-button" @click="toggleDocumentGenerationDialog(doc.templateName)" v-if="showTemplateButtons(doc)"> <span>{{doc.label}}</span></Button>
			</div>
		</template>
	</Sidebar>

	<!--Generate document dialog -->
	<DocumentGeneration :selectedDocumentTemplate="selectedDocumentTemplate"
						:selectedEmailTemplate="selectedEmailTemplate"
						:propertyData="propertyData"
						:toggledService="getServiceForToggledSupplier"
						:initialActiveTab="documentGenerationActiveTab"
						:recipientCompanyId="getServiceForToggledSupplier.supplierCompanyId"
						@updateShowDocumentGenerationComponent="showDocumentGenerationComponent = $event;"
						@reloadData="reloadData"
						v-if="showDocumentGenerationComponent" />
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyServiceData, ServiceData, PropertyData, GetAllAccessibleServicesQuery, EmailTemplateType, AutomatedEmailData } from '@/api-client/api-client'
	import { CompanyListFlags } from '@/utils/CompanyListFlags';
	import filterListBySearchString from '@/utils/StringSearch'
	import { CompassApi } from '@/api-client/CompassApiProxy'
	import { format, isValid, add } from 'date-fns';
	import { GetBwofServiceID, GetTrialEvacServiceID, GetCompassCompanyID, GetDocumentTypes, SupplierDocumentType } from '@/utils/CompassConstants';
	import Toast from '@/utils/Toast';

	@Options({
		name: 'PropertyServiceTable',
		components: {
		},
		props: {
			services: {
				type: Array,
				default: []
			},
			propertyData: null
		},
		watch: {
			showAddService(_value: boolean) {
				this.clearAddServiceData();
			}
		}
	})
	export default class PropertyServiceTable extends Vue {

		// Data
		services: PropertyServiceData[] = [];
		serviceListFilter = "";
		editMode = false;
		newService: PropertyServiceData = new PropertyServiceData();
		showAddService = false;
		serviceTypes = ['Full Service', 'Audit'];
		allServices: ServiceData[] = [];
		selectedNewService: ServiceData = new ServiceData();
		serviceIntervalOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
		loading = false;
		showNotes = false;

		/** Whether sidebar is visible */
		showSupplierDetails = false;

		/** The supplier currently shown in the sidebar (if any) */
		supplierSummaryId = 0;

		/** The row that was clicked when showing the selected supplier in the sidebar */
		serviceForToggledSupplier: PropertyServiceData = new PropertyServiceData;

		/** row clicked on when email is sent */
		serviceForAutomatedEmail: AutomatedEmailData = new AutomatedEmailData;

		isInternalUser = false;
		compassCompanyID = GetCompassCompanyID();

		propertyData: PropertyData = new PropertyData();
		selectedDocumentTemplate: string | null = null;
		selectedEmailTemplate: EmailTemplateType | null = null;
		showDocumentGenerationComponent = false;
		documentGenerationActiveTab = 0;

		documentTypes = GetDocumentTypes();

		loadedTime = new Date();

		showSnoozeOptions = false;
		selectedSnoozeDays: number | undefined = undefined;
		selectedPropertyServiceToSnooze: PropertyServiceData = new PropertyServiceData();
		snoozeOptions = [
			{
				label: '7 days',
				value: 7
			},
			{
				label: '14 days',
				value: 14
			},
			{
				label: '30 days',
				value: 30
			},
			{
				label: '6 months',
				value: 132
			}
		]

		created() {
			this.isInternalUser = this.$store.getters.isInternalUser;
		}

		// Computed
		get filteredServices() {
			let list = this.services.filter(s => s.whenDeleted == null);

			list = filterListBySearchString(list, this.serviceListFilter,
				(el) => el.propertyId
					+ ' ' + el.serviceName
					+ ' ' + el.serviceType
					+ ' ' + el.ref
					+ ' ' + el.adminNotes
					+ ' ' + el.supplierName
					+ ' ' + el.whenLastComplianceReceived
					+ ' ' + el.whenNextServiceAnniversary
					+ ' ' + el.adminNotes
					+ ' ' + el.exceptionNotes);

			return list;
		}

		get supplierList() {
			if (this.$store.state.companyList.data == null || this.$store.state.companyList.data.length == 0) {
				this.$store.dispatch('downloadCompanyList');
			}

			return this.$store.state.companyList.data.filter(c => CompanyListFlags.isSupplier(c));
		}

		// Computed isDesktop
		get isDesktop() {
			return window.innerWidth >= 992;
		}
		// Computed to simplify paginator on mobile
		get paginatorTemplate() {
			return this.isDesktop ?
				"CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				: "PrevPageLink NextPageLink"
		}

		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'dd MMM yyyy');
		}

		formattedDateTime(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'dd MMM yyyy HH:mm');
		}

		toggleNotes(data: PropertyServiceData) {
			if (!data.adminNotes || data.adminNotes.length == 0)
				data.adminNotes = ' ';
			if (!data.exceptionNotes || data.exceptionNotes.length == 0)
				data.exceptionNotes = ' ';
		}

		hasContent(content: string): boolean {
			return content != null && content.length > 0 && content.trim().length > 0;
		}

		hasContentOrWhitespace(content: string): boolean {
			return content != null && content.length > 0;
		}

		editModeChanged() {
			this.services.forEach(s => {
				if (s.adminNotes)
					s.adminNotes = s.adminNotes.trim();
				if (s.exceptionNotes)
					s.exceptionNotes = s.exceptionNotes.trim();
			});

			// ensure comments are visible when toggling edit mode
			if (this.editMode)
				this.showNotes = true;
		}

		toggleNewService() {
			if (this.showAddService) {
				this.showAddService = !this.showAddService;
				return;
			}

			this.loading = true;
			const apiClient = CompassApi.serviceApi(this.$store);

			const servicesQuery = new GetAllAccessibleServicesQuery();
			servicesQuery.sortType = 'default-sort'

			apiClient.getAllServices(servicesQuery)
				.then(result => {
					this.allServices = result;
					this.loading = false;
					this.showAddService = true;
				})
				.catch(error => {
					Toast.ApiError('Error retrieving service definitions', error);
				});
		}

		addService() {
			if (this.selectedNewService.serviceId) {
				this.newService.serviceId = this.selectedNewService.serviceId;
				this.newService.serviceName = this.selectedNewService.serviceName;
				this.newService.intervalMonths = this.selectedNewService.intervalMonths;
				this.newService.price = 0;
				this.newService.active = true;
				this.newService.supplierCompanyId = this.compassCompanyID;
				this.newService.serviceType = this.serviceTypes[0];
				this.newService.whenCreated = new Date();

				this.services.unshift(this.newService);
			}

			this.showAddService = false;
		}

		clearAddServiceData() {
			this.selectedNewService = new ServiceData();
			this.newService = new PropertyServiceData();
		}

		updateSupplierName(data: PropertyServiceData) {
			data.supplierName = this.supplierList.find(s => s.id == data.supplierCompanyId)?.name;
		}

		clearSupplierName(data: PropertyServiceData) {
			data.supplierName = undefined;
		}

		/** Currently called when clicking the info circle button */
		toggleSupplierDetails(data: PropertyServiceData) {
			this.supplierSummaryId = data.supplierCompanyId as number;
			this.serviceForToggledSupplier = data;
			this.showSupplierDetails = true;
		}

		addYear(date: Date) {
			if (!date) return;

			return add(date, { years: 1 });
		}

		toggleDocumentGenerationDialog(docType: string | null) {
			this.documentGenerationActiveTab = 0;
			this.selectedDocumentTemplate = docType;
			this.selectedEmailTemplate = null;
			this.showDocumentGenerationComponent = true;
		}

		toggleSupplierEnvelope(propertyService: PropertyServiceData) {
			const isBwofSubService = (propertyService.parentServiceId == 1);
			const isTrialEvacService = (propertyService.serviceId == 2);

			if (isBwofSubService)
			{
				// Check if parent has an anniversiry
				var parentHasAnniversary = true;
				if (propertyService.parentServiceId) {
					parentHasAnniversary = this.services.some(
						x => x.serviceId === propertyService.parentServiceId && x.whenNextServiceAnniversary
					);
				}

				// If due date not set for selected service or parent display toast
				if (!propertyService.whenNextServiceAnniversary || !parentHasAnniversary) {
					Toast.Info('Anniversary', `Anniversary needs to be set on BWOF and ${propertyService.serviceName} before generating email`);
					return;
				}

				// Will be recalculated to get most appropriate 12A request email based on dates
				this.selectedEmailTemplate = EmailTemplateType.Email_Auto_12A;

				if (propertyService.supplierCompanyId == this.compassCompanyID)
					this.selectedDocumentTemplate = "CertificateOfComplianceTemplate";
				else
					this.selectedDocumentTemplate = "CertificateOfComplianceTemplateExternal";

				// Select the second tab (email, as document tab is the first)
				this.documentGenerationActiveTab = 1;
			}

			// Currently not implemented
			else if (isTrialEvacService)
			{
				// Will be recalculated to get most appropriate trial evacuation request email based on dates
				this.selectedEmailTemplate = EmailTemplateType.Email_Auto_TrialEvac;

				// No document for this type of email
				this.selectedDocumentTemplate = null;

				// Select the first tab (email, as there is no document tab)
				this.documentGenerationActiveTab = 0;
		}
			else
			{
				Toast.Error('Clicked an unknown service type', '');
				return;
			}
			this.serviceForToggledSupplier = propertyService;
			this.showDocumentGenerationComponent = true;
		}

		getServiceClass(data: PropertyServiceData) {
			if (data.parentServiceId)
				return '';

			// if is newly added PropertyService
			if (data.whenCreated) {
				if (this.loadedTime < data.whenCreated)
					return '';
			}

			return 'main-service'
		}

		showTemplateButtons(doc: SupplierDocumentType) {
			if (this.getServiceForToggledSupplier.supplierCompanyId == this.compassCompanyID)
				return doc.showIfCompass;

			return doc.showIfExternal;
		}

		snoozedTooltip(data: PropertyServiceData) {
			if (data.whenSupplierEmailsSnoozedUntil)
				return 'Until: ' + this.formattedDateTime(data.whenSupplierEmailsSnoozedUntil);
			else
				return data.whenSupplierEmailsSnoozedUntil;
		}

		lastTriggeredTooltip(whenLastSupplierEmailTriggered?: Date) {
			if (whenLastSupplierEmailTriggered == null)
				return null;
			return 'Triggered at ' + this.formattedDateTime(whenLastSupplierEmailTriggered);
		}

		reloadData() {
			this.$emit('reloadData');
		}

		isBwofSubService(data: PropertyServiceData) {
			return data.parentServiceId == GetBwofServiceID();
		}

		isTrialEvacService(data: PropertyServiceData) {
			return data.serviceId == GetTrialEvacServiceID();
		}

		showEnvelopeForSubServiceLine(data: PropertyServiceData) {
			return this.isBwofSubService(data) || this.isTrialEvacService(data)
		}

		get getServiceForToggledSupplier() {
			return this.serviceForToggledSupplier;
		}
	}
</script>

<style scoped lang="scss">
	.property-service-table {
		font-size: 15px;
	}

	.property-service-item {
		padding-left: 4px;
		padding-right: 3px;
		padding-top: 2px;
		margin-bottom: 6px;

		.notes-block {
			padding: 5px;
			margin-right: 3px;
			display: flex;
			// border-top: 1px solid #eee;
		}

		.notes-block-label {
			min-width: 65px;
			max-width: 65px;
			font-size: 13px;
			text-align: left;
			padding-left: 2px;
			padding-right: 4px;
		}

		.notes-block-content {
			white-space: pre-wrap;
			width: 100%;
		}

		.service-name {
			font-weight: 700;


			@media screen and (max-width: 600px) {
				margin-right: 2rem;
			}
		}
	}

	.main-service {
		background-color: #DCDCDC;
		border-bottom: 1px solid #ccc;
	}

	.service-type {
		width: 110px;

		@media screen and (min-width: 1500px) {
			width: 155px;
		}
	}

	.service-ref {
		width: 80px;
	}

	.property-services-section {
		@media screen and (max-width: 1300px) {
			padding: 0.75rem !important;
		}
	}

	.template-button {
		margin-bottom:10px;
		width:100%;
		border-radius:20px;
	}
</style>